import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { unsubscribeOsnService } from "@WhiteCap/Store/Service/OsnSubscriptionsServices/UnsubscribeOsnService";

export interface UnsubscribeOsnApiParameter extends ApiParameter {
    email: string;
    onError?: (error: string) => void;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandler<UnsubscribeOsnApiParameter, unknown>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await unsubscribeOsnService(props.apiParameter.email);
    if (!result.successful) {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        return false;
    }
    if (props.apiParameter?.onSuccess) {
        props.apiParameter.onSuccess();
    }
};

export const chain = [PopulateApiParameter, MakeApiRequest];

const unsubscribeOsn = createHandlerChainRunner(chain, "UnsubscribeOsn");
export default unsubscribeOsn;
